import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  ACCList,
  getAccountingEntryByAccReference,
} from '../../services/accounting';
import Text from 'antd/lib/typography/Text';

import { toCurrency } from '../../utils/utils';
import DataGrid, { DataGridColDef } from '../DataGrid/DataGrid';

type AccountingEntriesTableProps = {
  accmodel: string;
  accreference: string;
  objectid: number;
  isActive?: boolean;
};

const AccountingEntriesTable = (props: AccountingEntriesTableProps) => {
  const { accmodel, accreference, objectid,isActive } = props;

  const params = { accmodel, accreference, objectid };

  const { data, isFetching } = useQuery(
    ['getAccountingEntriesByAccReference', params],
    () => getAccountingEntryByAccReference(params).then((res) => res.list || []),
    {enabled: isActive===true}
  );

  const columns = useMemo<DataGridColDef<ACCList>[]>(
    () => [
      {
        comcode: 'AccountingTable.accreference',
        dataIndex: 'accreference',
        width: 100,
      },
      {
        comcode: 'AccountingTable.acclabel',
        dataIndex: 'acclabel',
        width: 200,
      },
      {
        comcode: 'AccountingTable.objectlabel',
        dataIndex: 'objectlabel',
        width: '50%',
      },
      {
        comcode: 'AccountingTable.debit',
        dataIndex: 'debit',
        width: 150,
        align: 'right',
        render: (debit,record) =>
          debit === 0 ? '-' : <Text type="danger">{toCurrency(debit)}</Text>,
      },
      {
        comcode: 'AccountingTable.credit',
        dataIndex: 'credit',
        width: 150,
        align: 'right',
        render: (credit) =>
          credit === 0 ? '-' : <Text type="danger">{toCurrency(credit)}</Text>,
      },
    ],
    []
  );

  return (
    <DataGrid
      dataSource={data}
      columns={columns}
      isLoading={isFetching}
      rowKey={({ aceid }) => aceid}
    />
  );
};

export default AccountingEntriesTable;
